import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import CheckoutForm from './checkoutForm';

const key =
  __DEV__ || __TEST__
    ? 'pk_test_51PGKL3BzrVh8ZDjOJDJBZ6lr851oGwhIEqPaCvEpS11YJfAoDbIYOLN97WfvieeBi2iiQEARHQP1RbdKsnhPowtK00BWOJuld6'
    : 'pk_live_51PGKL3BzrVh8ZDjOXSnsBxL8EbOUXgUhMFNUhO3xN5zxpjP96f3VRg9MTd2CBzYnynmfaIgr3a3KFFX82IdciLh500e1FIWbNf';
const stripePromise = loadStripe(key);

export function Stripe(props) {
  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret: props.paymentInfo
      }}
    >
      <CheckoutForm amount={props.amount} />
    </Elements>
  );
}
